/**
 * 加上 千分號
 * @return {String} 千分號
 */
const commaFormat = function(value) {
    return value
        .toString()
        .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function(
            all,
            pre,
            groupOf3Digital
        ) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
        });
};
/**
 * 加上 $ 字號
 * @return {String} $ 字號
 */
const priceFormat = function(value) {
    return '$' + value;
};

export { commaFormat, priceFormat };
